import { fromJS } from 'immutable'

export const changeSemState = fromJS({
  sy: '',
  sem: '',
})



// WEBPACK FOOTER //
// ./src/containers/Admin/reducer.js